import { toastDedupedError } from "./toast";

export const ACTION_OUTCOME_SAVE_FAILURE_MESSAGE = "Failed to update this issue. Please try again.";
const ACTION_OUTCOME_SAVE_FAILURE_TOAST_ID = "action-outcome-save-failure";

export function toastActionOutcomeSaveFailure(): void {
  toastDedupedError(ACTION_OUTCOME_SAVE_FAILURE_MESSAGE, ACTION_OUTCOME_SAVE_FAILURE_TOAST_ID);
}

export async function saveActionOutcomeOrToast(save: () => Promise<void>): Promise<void> {
  try {
    await save();
  } catch {
    toastActionOutcomeSaveFailure();
  }
}
